import React from 'react';
import { footerNavGroups, legalLinks } from '../data';
import { FooterProps } from '../types';
import FooterPresentation from './FooterPresentation';

/**
 * Container component for Footer, responsible for providing data
 */
const FooterContainer: React.FC<FooterProps> = () => {
  return (
    <FooterPresentation
      navGroups={footerNavGroups}
      legalLinks={legalLinks}
    />
  );
};

export default FooterContainer;